import { Card, message, Button, Space } from 'antd';
import Clipboard, { Event } from 'clipboard';
import { observer } from 'mobx-react';
import React, { useState, useEffect } from 'react';
import holderImg from '@/assets/images/public/no-permission.svg';
import { getParamFromUrl } from '@/infrastructure/history';
import { useAuthContext } from '@/presentation/hooks';
import { SendPermission } from './dialog/send-permission';
import { SubmitResult } from './dialog/submit-result';
import style from './index.module.scss';

export const InternalPermission = observer(() => {
  const productId = getParamFromUrl('productId');
  const { authInfo } = useAuthContext();
  const [permissionDialogVisible, setPermissionDialogVisible] = useState(false);
  const [submitDialogVisible, setSubmitDialogVisible] = useState(false);
  const [submitResult, setIsSubmitResult] = useState('succ');
  const [clipboard, setClipboard] = useState<ClipboardJS>();

  useEffect(() => {
    setClipboard(new Clipboard('#copyBtn'));
    return () => {
      clipboard?.destroy();
    };
  }, []);

  const showCopyMessage = () => {
    clipboard?.on('success', () => {
      message.destroy();
      message.success('复制成功');
    });
    clipboard?.on('error', (e: Event) => {
      message.destroy();
      message.error('复制失败');
      console.log('复制失败==>', e.trigger, e.action);
    });
  };

  return <Card bordered={false} style={{ flex: 1, background: '#f0f2f5' }}>
    <div className={style.holder}>
      <img src={holderImg} alt={''} />
      <h4 className={style.subtitle}>温馨提示</h4>
      <div className={style.subDesc}>
        <p> 尊敬的用户，你当前还没有加入任何Bugly的产品，请联系相关产品的管理员将你添加到项目成员中，或者联系Bugly小助手。</p>
        <p>（你的用户 ID为：{authInfo.userInfo.buglyUserId}，详情请点击右上角头像，查看个人信息。）</p>
      </div>
      <Space>
        <Button style={{ border: 'none', background: '#EBEFF5' }} onClick={() => location.reload()}>刷新</Button>
        {productId && <Button onClick={() => setPermissionDialogVisible(true)} type={'primary'}>申请加入项目</Button>}
      </Space>
    </div>
    <SendPermission
      permissionDialogVisible={permissionDialogVisible}
      setPermissionDialogVisible={setPermissionDialogVisible}
      setIsSubmitResult={setIsSubmitResult}
      setSubmitDialogVisible={setSubmitDialogVisible}
    />
    <SubmitResult
      showCopyMessage={showCopyMessage}
      submitResult={submitResult}
      submitDialogVisible={submitDialogVisible}
      setSubmitDialogVisible={setSubmitDialogVisible}
    />
  </Card>;
});
